import Image from 'next/image';

import {
	BurstAmount,
	BurstInner,
	BurstOuter,
	BurstWrapper,
	Jumbo,
} from './styles';

export const BurstToast = ({ amount }: { amount: string }) => (
	<BurstWrapper>
		<Jumbo className="BurstToast__jumbo">
			<Image
				src="/img/neurons/gem-icon.png"
				width={130}
				height={130}
				quality={100}
				alt="neuron image"
			/>
		</Jumbo>
		<BurstOuter className="BurstToast__outer">
			<BurstInner className="BurstToast__inner">
				<BurstAmount>
					+{amount}
					<span>neurons</span>
				</BurstAmount>
			</BurstInner>
		</BurstOuter>
	</BurstWrapper>
);
